import { render, staticRenderFns } from "./AlarmsConfigurationList.vue?vue&type=template&id=f994e5de&scoped=true&"
import script from "./AlarmsConfigurationList.vue?vue&type=script&lang=js&"
export * from "./AlarmsConfigurationList.vue?vue&type=script&lang=js&"
import style0 from "./AlarmsConfigurationList.vue?vue&type=style&index=0&id=f994e5de&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f994e5de",
  null
  
)

export default component.exports